<template>
  <div v-if="model" id="reservation">
    <div id="content">
      <h1>{{ lang.reserve_the }} {{ vehicle.name }}</h1>

      <Form
        ref="form"
        :requiredFields="required_fields"
        :hiddenFields="hidden_fields"
        :disabledFields="disabled_fields"
        :onSubmit="onSubmit"
        :onSuccess="onSuccess"
        :onFail="onFail"
        :onDone="onDone"
      >
        <b-tabs content-class="mt-3">
          <b-tab title="Contract">
            <div class="row">
              <div class="col-md-9">
                <div class="row">
                  <div class="col-md-6">
                    <fieldset class="bg-white rounded p-3 mb-3">
                      <div class="form-group row">
                        <div class="col-sm-12">
                          <h2>{{ lang.general }}</h2>
                        </div>
                      </div>

                      <HiddenInput :model="model" name="id" />

                      <HiddenInput :model="model" name="vehicle_id" />

                      <HiddenInput :model="model" name="client_id" />

                      <HiddenInput :model="model" name="contract_template_id" />

                      <TextReadonly
                        v-if="contract_template"
                        :label="lang.profile"
                        :model="contract_template"
                        name="name"
                      />

                      <TextReadonly
                        :label="lang.client"
                        :model="client.company"
                        name="name"
                      />

                      <!-- <Select
                        v-if="hasDepotRole"
                        :label="lang.client"
                        :model="model"
                        :options="clients"
                        @change="onClientChange"
                        name="client_id"
                      />-->

                      <TextInput
                        :label="lang.order_number"
                        :model="model"
                        name="order_number"
                      />

                      <!-- <FormGroup name="vehicle.segment"> -->
                      <Select
                        :label="lang.allowed_segments"
                        :model="model"
                        :options="segments"
                        name="vehicle_segment_id"
                      />
                      <!-- </FormGroup> -->

                      <TextInput
                        :label="lang.signature"
                        :model="model"
                        name="signature"
                      />

                      <Select v-if="field_config?.cost_center?.input_type === 'select'"
                        :label="lang.cost_center"
                        :model="model"
                        :options="field_config?.cost_center?.select_options"
                        name="cost_center"
                      />

                      <TextInput v-else
                      :label="lang.cost_center"
                      :model="model"
                      name="cost_center"
                      />

                      <Select
                        :label="lang.lease_company"
                        :model="model"
                        @change="onLeaseCompanyChange()"
                        :options="
                          [{ value: 0, text: i18n.app.n_a }].concat(
                            lease_companies
                          )
                        "
                        name="lease_company_id"
                      />

                      <RadioGroup
                        :label="lang.credit_type"
                        :model="model"
                        :options="credit_types"
                        name="credit_type"
                        @change="onCreditTypeChange"
                      />

                      <FormGroup
                        v-if="model.cost_determinations"
                        :name="
                          'cost_determinations.' +
                            cost_determination_car_pickup.id
                        "
                      >
                        <RadioGroup
                          :label="i18n.app.components.contract.car_pickup"
                          ref="contractCostDeterminationCarPickUp"
                          :required="true"
                          :model="
                            model.cost_determinations[
                              cost_determination_car_pickup.id
                            ]
                          "
                          :options="
                            COST_DETERMINATION_SELECTIONS.filter(
                              item =>
                                item !=
                                  CostDeterminationSelection.LEASE_COMPANY ||
                                model.lease_company_id
                            ).map(item => ({
                              value: item,
                              text: i18n.app.common.fields[item.toLowerCase()]
                            }))
                          "
                          :disabled="
                            model.id || isLeaseCompanyCoveringCarPickupCosts()
                              ? true
                              : false
                          "
                          @change="onContractCostDeterminationChange"
                          name="selection"
                        />
                      </FormGroup>

                      <DatePicker
                        :label="lang.start_date"
                        :model="model"
                        @change="onStartDatetimeChange"
                        name="start_datetime"
                        :disabled="model.id ? true : false"
                        :min="start_datetime_settings.min_date"
                        :max="start_datetime_settings.max_date"
                      />

                      <DateDifferenceInput
                        ref="dateDifferenceInput"
                        :is_business_days_only="
                          contract_template &&
                            contract_template.is_business_days_only
                        "
                        :round="true"
                        :round_up_after="
                          vgvs[
                            vehicle.is_domestic
                              ? 'leniency_in_hours'
                              : 'leniency_in_hours_foreign'
                          ]
                        "
                        :label="lang.num_of_days"
                        :model="model"
                        :disabled="
                          disabled_fields.includes('start_datetime') ||
                            disabled_fields.includes('end_datetime')
                        "
                        @change="onDateDifferenceChange"
                        start="start_datetime"
                        end="end_datetime"
                        name="num_of_days"
                      />

                      <DatePicker
                        ref="endDatetimeDatepicker"
                        @change="onEndDatetimeChange"
                        :label="lang.end_date"
                        :model="model"
                        name="end_datetime"
                        :disabled="model.id ? true : false"
                        :min="end_datetime_settings.min_date"
                        :max="end_datetime_settings.max_date"
                        :disabledHours="
                          end_datetime_settings.disabled_hours || []
                        "
                        :noWeekendsDays="
                          end_datetime_settings.no_weekend_days || false
                        "
                        :disabledDates="
                          end_datetime_settings.disabled_dates || []
                        "
                      />
                    </fieldset>

                    <fieldset class="bg-white rounded p-3 mb-3">
                      <div class="form-group row">
                        <div class="col-sm-12">
                          <h2>{{ lang.driver_information }}</h2>
                        </div>
                      </div>

                      <FormGroup name="customer">
                        <TextInput
                          :label="lang.email"
                          :model="model.customer"
                          name="email"
                        />

                        <div class="row">
                          <div class="col-sm-4">
                            <div class="form-group">
                              <label
                                class="col-form-label"
                                :class="
                                  disabled_fields.indexOf('customer.phone') > -1
                                    ? 'disabled'
                                    : null
                                "
                              >
                                {{ lang.mobile }}
                                <span
                                  v-if="
                                    required_fields.indexOf('customer.phone') >
                                      -1
                                  "
                                  class="required"
                                  >*</span
                                >
                              </label>
                            </div>
                          </div>
                          <div class="col-sm-8">
                            <div class="row">
                              <div class="col-sm-4">
                                <Select
                                  :label="false"
                                  :indent="false"
                                  :model="model.customer"
                                  :options="phone_countries"
                                  name="phone_country_id"
                                />
                              </div>
                              <div class="col-sm-8">
                                <TextInput
                                  :indent="false"
                                  :label="false"
                                  :model="model.customer"
                                  name="phone"
                                  :placeholder="i18n.app.common.fields.phone"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <RadioGroup
                          :label="lang.gender"
                          :model="model.customer"
                          :options="genders"
                          name="gender"
                        />

                        <TextInput
                          :label="lang.initials"
                          :model="model.customer"
                          name="initials"
                        />

                        <TextInput
                          :label="lang.insertion"
                          :model="model.customer"
                          name="insertion"
                        />

                        <TextInput
                          :label="lang.name"
                          :model="model.customer"
                          name="name"
                        />

                        <FormGroup name="address">
                          <FormGroupAddress
                            :model="model.customer.address"
                            @countryChanged="onCountryChanged"
                            :countries="countries"
                          />
                        </FormGroup>
                      </FormGroup>
                    </fieldset>

                    <fieldset class="bg-white rounded p-3 mb-3">
                      <div class="form-group row">
                        <div class="col-sm-12">
                          <h2>{{ lang.messaging.title }}</h2>
                        </div>
                      </div>

                      <Checkbox
                        :model="model"
                        id="reminder-message"
                        name="sign_off_reminder_enabled"
                        :label="lang.messaging.sign_off_reminder_enabled"
                      />
                    </fieldset>

                    <fieldset class="bg-white rounded p-3 mb-3">
                      <div class="form-group row">
                        <div class="col-sm-12">
                          <h3>{{ i18n.app.common.fields.language }}</h3>
                          <p>{{ lang.language_text }}</p>
                        </div>
                      </div>

                      <Select
                        ref="countryIdsSelect"
                        :key="'country_ids_' + model.country_ids.join(',')"
                        :label="lang.letter_language"
                        :model="model"
                        :multi="true"
                        @select="onLanguageSelect"
                        @deselect="onLanguageDeselect"
                        :options="languages"
                        name="country_ids"
                      />
                    </fieldset>
                  </div>
                  <div class="col-md-6">
                    <fieldset class="bg-white rounded p-3 mb-3">
                      <div class="form-group row">
                        <div class="col-sm-12">
                          <h2>{{ lang.conked_out_vehicle }}</h2>
                        </div>
                      </div>

                      <FormGroup name="conked_out_vehicle">
                        <Select
                          :label="lang.conked_out_vehicle_country"
                          :model="model.conked_out_vehicle"
                          :options="license_plate_countries"
                          name="country_id"
                        />

                        <TextInputLicensePlate
                          :label="lang.conked_out_license_plate"
                          :countryCode="
                            get(
                              license_plate_countries.find(
                                item =>
                                  item.value ==
                                  model.conked_out_vehicle.country_id
                              ),
                              'text'
                            )
                          "
                          :countries="countries"
                          :model="model.conked_out_vehicle"
                          name="license_plate"
                          @search="onLicensePlateSearchStart"
                          @searched="onLicensePlateSearchComplete"
                        />

                        <TextInput
                          ref="conkedOutVehicleBrandName"
                          :label="lang.conked_out_brand"
                          :model="model.conked_out_vehicle"
                          name="brand_name"
                          :loading="state.is_searching_license_plate"
                        />

                        <TextInput
                          ref="conkedOutVehicleModelName"
                          :label="lang.conked_out_model"
                          :model="model.conked_out_vehicle"
                          name="model_name"
                          :loading="state.is_searching_license_plate"
                        />

                        <RadioGroup
                          :label="lang.stranding_type"
                          :model="model.conked_out_vehicle"
                          :options="stranding_types"
                          name="stranding_type"
                        />

                        <TextInput
                          :label="lang.stranding_remark"
                          :required="
                            model.conked_out_vehicle.stranding_type ==
                              StrandingType.OTHER
                          "
                          :model="model.conked_out_vehicle"
                          :multiline="true"
                          name="remark"
                        />
                      </FormGroup>
                    </fieldset>

                    <fieldset
                      class="bg-white rounded p-3 mb-3"
                      v-if="
                        contract_template
                          ? !contract_template.is_hiding_charges
                          : true
                      "
                    >
                      <div class="form-group row">
                        <div class="col-sm-12">
                          <h2>{{ lang.cost_determinations }}</h2>
                        </div>
                      </div>

                      <div
                        v-if="
                          lowered_deductable_excess_min_num_of_days >= 1 &&
                            model.num_of_days >=
                              lowered_deductable_excess_min_num_of_days
                        "
                      >
                        <Checkbox
                          :model="model"
                          name="is_using_lowered_deductable_excess"
                          :label="lang.is_using_lowered_deductable_excess + ' (€' + lowered_deductable_excess_reduction_cost_per_day + ' ' + i18n.database.table.prices.unit.DAY.toLowerCase() + ')'"
                        />
                        <Select v-if="model.is_using_lowered_deductable_excess"
                          :label="lang.lowered_deductible_excess_costs"
                          :model="model"
                          :options="
                            lowered_deductible_excess_costs_receiver_types
                          "
                          name="lowered_deductible_excess_costs_receiver_type"

                        ></Select>
                        <!-- :options="[{ value: 0, text: i18n.app.n_a }].concat(lowered_deductible_excess_costs_receiver_types)" -->
                      </div>

                      <ContractCostDeterminationsEdit
                        v-if="model.cost_determinations"
                        v-bind:key="
                          'CostDeterminationSelection-' + model.credit_type
                        "
                        :errors="$refs.form && $refs.form.errors"
                        :model="model.cost_determinations"
                        :costDeterminations="cost_determinations"
                        :disabled="model.id ? true : false"
                        @mounted="onContractCostDeterminationsMounted"
                        @change="onContractCostDeterminationChange"
                        :enabledSelectionTypes="
                          !hasSelectedLeaseCompany()
                            ? [
                                CostDeterminationSelection.INSURER,
                                CostDeterminationSelection.CUSTOMER
                              ]
                            : null
                        "
                        ref="contractCostDeterminations"
                      />
                    </fieldset>

                    <fieldset class="bg-white rounded p-3 mb-3">
                      <div class="form-group row">
                        <div class="col-sm-12">
                          <h2>{{ lang.drop_off_title }}</h2>
                        </div>
                      </div>

                      <RadioGroup
                        :label="lang.drop_off_location"
                        :options="location_types_drop_off"
                        :model="model"
                        name="location_type_drop_off"
                      />

                      <TextReadonly
                        v-if="
                          model.location_type_drop_off == LocationType.DEPOT
                        "
                        :label="lang.drop_off_depot"
                        :model="vehicle.depot"
                        name="name"
                      />

                      <!-- <Select v-if="model.location_type_drop_off == LocationType.DEPOT" :label="lang.drop_off_depot" :model="model" :options="depots" name="depot_id_drop_off" @change="recalculatePrices"/> -->

                      <FormGroup name="address_drop_off">
                        <FormGroupAddress
                          v-if="
                            model.location_type_drop_off == LocationType.OTHER
                          "
                          :withName="true"
                          :model="model.address_drop_off"
                          :countries="countries"
                        />
                      </FormGroup>
                    </fieldset>

                    <fieldset class="bg-white rounded p-3 mb-3">
                      <div class="form-group row">
                        <div class="col-sm-12">
                          <h2>{{ lang.return_title }}</h2>
                        </div>
                      </div>

                      <RadioGroup
                        :label="lang.return_location"
                        @change="$forceUpdate()"
                        :model="model"
                        :options="location_types_return"
                        name="location_type_return"
                      />

                      <Select
                        v-if="model.location_type_return == LocationType.DEPOT"
                        :label="lang.return_depot"
                        @change="onReturnDepotChange"
                        :model="model"
                        :options="depots"
                        name="depot_id_return"
                      />

                      <FormGroup name="address_return">
                        <FormGroupAddress
                          v-if="
                            model.location_type_return == LocationType.OTHER
                          "
                          :withName="true"
                          :model="model.address_return"
                          :countries="countries"
                        />
                      </FormGroup>
                    </fieldset>

                    <fieldset
                      class="bg-white rounded p-3 mb-3"
                      v-if="shouldShowPriceOverview()"
                    >
                      <div class="form-group row">
                        <div class="col-sm-12">
                          <h2>{{ lang.price_overview.title }}</h2>
                        </div>
                      </div>

                      <ContractPriceOverview
                        :start_datetime="model.start_datetime"
                        :end_datetime="model.end_datetime"
                        :deployment_prices="deployment_prices"
                        :day_prices="day_prices"
                        :day_prices_discounted="day_prices_discounted"
                        :is_domestic="vehicle.is_domestic"
                        ref="priceOverview"
                      />
                    </fieldset>

                    <div class="form-group row mt-2 mb-5">
                      <div class="col-md-6">
                        <a
                          v-if="!model.id"
                          @click="onCancelPress"
                          tabindex="0"
                          class="btn btn-primary w-50"
                          >{{ i18n.app.common.cancel }}</a
                        >
                      </div>
                      <div class="col-md-6 pr-0 text-right">
                        <button
                          v-if="!model.id"
                          :disabled="state.is_submitting"
                          @click="onSubmitClick"
                          class="btn btn-secondary w-50"
                        >
                          {{
                            model.id
                              ? i18n.app.common.save
                              : i18n.app.common.reserve
                          }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="bg-white rounded p-3 mb-4">
                  <ContractCountdown
                    v-if="!model.id"
                    ref="contractCountdown"
                    :vehicle="vehicle"
                  />

                  <VehicleItem
                    :hideBookButton="true"
                    :model="vehicle"
                    :standalone="true"
                  />

                  <hr class="my-4" />

                  <DepotInfoItem :model="vehicle.depot" :standalone="true" />
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab
            :title="
              i18n.app.components.contract.remarks +
                (model.remarks && model.remarks.length
                  ? ` (${model.remarks.length})`
                  : '')
            "
          >
            <div>
              <h5>{{ lang.remarks }}</h5>
            </div>

            <div
              class="row"
              v-for="remark in model.public_remarks"
              :key="remark.id"
            >
              <div class="col-md-6">
                <div class="bg-white rounded mb-3 p-3">
                  <div class="mb-4">
                    <div>
                      <small v-if="remark.user"
                        >{{ remark.user.name || remark.user.email }} •</small
                      >
                      <small v-if="remark.created_at">
                        {{ remark.created_at }}
                      </small>
                    </div>
                    <div>{{ remark.text }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <TextInput
                  :label="false"
                  :placeholder="lang.new_remark"
                  :indent="false"
                  :model="model"
                  :multiline="true"
                  name="remark"
                />
              </div>
            </div>
          </b-tab>
          <b-tab
            v-if="model.public_attachments"
            :title="
              i18n.app.components.contract.attachments +
                (model.public_attachments && model.public_attachments.length
                  ? ` (${model.public_attachments.length})`
                  : '')
            "
          >
            <div>
              <h5>{{ lang.images }}</h5>
            </div>

            <div class="row">
              <div
                class="col-md-6"
                v-for="attachment in model.public_attachments"
                :key="attachment.id"
              >
                <div class="bg-white rounded p-3">
                  <!--
                    attachment.url is the expiring URL minted by MediaUrl. It may
                    point at the object store rather than at us, so open it in a
                    new tab: the download attribute is ignored cross origin and a
                    same tab navigation would throw away the open form.
                  -->
                  <a
                    v-if="attachment.mime.indexOf('image/') > -1"
                    :href="attachment.url"
                    target="_blank"
                    rel="noopener"
                    download
                  >
                    <!--
                      Writing the refreshed URL back onto the attachment also fixes
                      the href above it, so the link a user clicks after the tab has
                      been open for a while points at the URL the image is showing.
                    -->
                    <ExpiringImage
                      :src="attachment.url"
                      type="attachment"
                      :record-id="attachment.id"
                      @refreshed="url => (attachment.url = url)"
                    />
                  </a>
                  <a
                    v-else
                    class="text-color"
                    :href="attachment.url"
                    target="_blank"
                    rel="noopener"
                    download
                    >{{ attachment.filename_stored }}</a
                  >
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </Form>
    </div>
  </div>
</template>

<script>
import * as get from "lodash/get";
import Contract, { LocationType, CreditType } from "@/models/Contract";
import { StrandingType } from "@/models/ConkedOutVehicle";
import {
  CostDeterminationSelection,
  ContractCostDeterminationType,
  COST_DETERMINATION_SELECTIONS
} from "@/models/ContractCostDetermination";
import Vehicle from "@/models/Vehicle";
import Client from "@/models/Client";
import {
  Form,
  FormGroupAddress,
  Checkbox,
  HiddenInput,
  TextInput,
  TextInputLicensePlate,
  FormGroup,
  DatePicker,
  TextReadonly,
  DateDifferenceInput,
  Select,
  RadioGroup
} from "@/components/common/form";

import { VehicleItem } from "@/components/crud/vehicle";
import { DepotInfoItem } from "@/components/crud/depot";
import FilterGroupCollection from "@/objects/FilterGroupCollection";
import ContractService from "@/services/ContractService";
import ClientService from "@/services/ClientService";
import ContractCountdown from "./partials/ContractCountdown";
import ContractCostDeterminationsEdit from "./partials/ContractCostDeterminationsEdit";
import ContractPriceOverview from "./partials/ContractPriceOverview";
import { mapGetters } from "vuex";
import pick from "lodash/pick";
import { MapState } from "@/components/map/MapComponent";
import ExpiringImage from "@/components/common/ExpiringImage";
import toWeekday from "@/helpers/toWeekday";

const contractService = new ContractService();
const clientService = new ClientService();

export default {
  name: "contract-edit",
  components: {
    TextInput,
    HiddenInput,
    TextInputLicensePlate,
    Select,
    RadioGroup,
    Checkbox,
    FormGroupAddress,
    DatePicker,
    DateDifferenceInput,
    VehicleItem,
    DepotInfoItem,
    ExpiringImage,
    Form,
    TextReadonly,
    FormGroup,
    ContractCountdown,
    ContractCostDeterminationsEdit,
    ContractPriceOverview
  },
  data() {
    return {
      state: {
        is_submitting: false,
        manually_selected_language_ids: [],
        is_searching_license_plate: false,
        is_first_cost_determination_mount: true
      },
      hasDepotRole: this.$store.getters.hasDepotRole,
      required_fields: this.$route.params.required_fields,
      hidden_fields: this.$route.params.hidden_fields,
      field_config: this.$route.params.field_config,
      disabled_fields: this.$route.params.disabled_fields || [],
      LocationType: LocationType,
      model: this.$route.params.model
        ? new Contract(this.$route.params.model)
        : null,
      start_datetime_settings: this.$route.params.start_datetime_settings,
      end_datetime_settings: this.$route.params.end_datetime_settings,
      segments: this.$route.params.segments,
      lease_companies: this.$route.params.lease_companies,
      credit_types: this.$route.params.credit_types,
      stranding_types: this.$route.params.stranding_types,
      genders: this.$route.params.genders,
      license_plate_countries: this.$route.params.license_plate_countries,
      phone_countries: this.$route.params.phone_countries,
      lowered_deductible_excess_costs_receiver_types: this.$route.params
        .lowered_deductible_excess_costs_receiver_types,
      lowered_deductable_excess_reduction_cost_per_day: this.$route.params.lowered_deductable_excess_reduction_cost_per_day,
      lowered_deductable_excess_min_num_of_days: this.$route.params
        .lowered_deductable_excess_min_num_of_days,
      location_types_drop_off: this.$route.params.location_types_drop_off,
      location_types_return: this.$route.params.location_types_return,
      countries: this.$route.params.countries,
      languages: this.$route.params.languages,
      supplier: this.$route.params.supplier,
      depots: this.$route.params.depots,
      clients: this.$route.params.clients || [],
      vehicle: new Vehicle(this.$route.params.vehicle),
      contract_template: this.$route.params.contract_template,
      cost_determinations: this.$route.params.cost_determinations,
      cost_determinations_map: this.$route.params.cost_determinations_map,
      contract_cost_determinations_dict: null,
      deployment_prices: this.$route.params.deployment_prices,
      day_prices: this.$route.params.day_prices,
      day_prices_discounted: this.$route.params.day_prices_discounted,
      selected_vehicle_segment_ids: FilterGroupCollection.load()?.findFilterValueByFilterKey('vehicle_segment_id'),
      StrandingType: StrandingType,
      vgvs: this.$route.params.vehicle_group_vehicle_segment,
      client: new Client(
        this._clients().find(item => item.id == this.$route.query.client_id)
      ),
      lang: i18n.app.components.contract,
      CostDeterminationSelection: CostDeterminationSelection,
      COST_DETERMINATION_SELECTIONS: COST_DETERMINATION_SELECTIONS,
      cost_determination_car_pickup: this.$route.params.cost_determinations.find(
        item => item.type === ContractCostDeterminationType.CAR_PICK_UP
      )
    };
  },
  mounted() {
    if (!this.model) {
      const model = new Contract();
      model.start_datetime = new Date();
      model.end_datetime = new Date(model.start_datetime.getTime() + 86400000);
      model.client_id = this.client.id;
      model.contract_template_id = this.contract_template?.id;
      const countryId = this.$store.state.user.preference.country_id;

      model.customer.address.country_id = countryId;
      model.customer.phone_country_id = countryId;
      model.conked_out_vehicle.country_id = countryId;
      model.country_id = countryId;
      model.address_drop_off.country_id = countryId;
      model.address_return.country_id = countryId;

      if (this.contract_template) {
        model.credit_type = this.contract_template.credit_type;
        model.num_of_days = this.contract_template.contract_duration_in_days;
      }

      model.lowered_deductible_excess_costs_receiver_type = null;

      model.location_type_drop_off = LocationType.DEPOT;
      model.location_type_return = LocationType.UNKNOWN;
      model.depot_id_drop_off = this.vehicle.depot_id;
      model.depot_id_return = this.vehicle.depot_id;
      model.vehicle_id = this.$route.query.vehicle_id;

      model.country_ids = this.getDefaultCountryIds(model);

      this.model = model;
    } else {
      if (!this.model.lease_company_id) this.model.lease_company_id = 0;
    }

    const defaultCountryIds = this.getDefaultCountryIds(this.model);
    this.state.manually_selected_language_ids = this.model.country_ids.filter(
      countryId => !defaultCountryIds.includes(countryId)
    );

    this.initContractCostDeterminationDict(
      this.cost_determinations,
      this.cost_determinations_map,
      this.model.contract_cost_determinations
    );
    setTimeout(() => this.$refs.form.init());
  },
  methods: {
    get: get,
    hasSelectedLeaseCompany() {
      return this.model.lease_company_id > 0;
    },
    onLeaseCompanyChange() {
      let leaseCompany = this.lease_companies.find(
        item => item.value == this.model.lease_company_id
      )?.data;

      if (leaseCompany) {
        if (leaseCompany.is_covering_car_pickup_costs) {
          this.model.cost_determinations[
            this.cost_determination_car_pickup.id
          ] = {
            selection: CostDeterminationSelection.LEASE_COMPANY,
            locked: true
          };
        }

        if (!this.contract_template) {
          clientService.find(this.model.lease_company_id).then(client => {
            if (
              !this.contract_template &&
              client.client_cost_determinations?.length
            ) {
              this.initContractCostDeterminationDict(
                this.cost_determinations,
                this.cost_determinations_map,
                client.client_cost_determinations
              );
            }
          });
        }
      } else {
        for (const id in this.model.cost_determinations) {
          if (this.model.cost_determinations.hasOwnProperty(id)) {
            const item = this.model.cost_determinations[id];
            if (item.selection == CostDeterminationSelection.LEASE_COMPANY) {
              item.selection = null;
            }
          }
        }
      }

      this.$forceUpdate();
    },

    isLeaseCompanyCoveringCarPickupCosts() {
      if (!this.model.cost_determinations) return false;
      if (!this.model.lease_company_id) return false;

      if (
        this.lease_companies.find(
          item => item.value == this.model.lease_company_id
        ).data.is_covering_car_pickup_costs
      )
        return true;

      return false;
    },
    onContractCostDeterminationsMounted() {
      if (this.model.id) {
        return;
      }

      if (this.state.is_first_cost_determination_mount) {
        if (this.model.credit_type)
          this.onCreditTypeChange(this.model.credit_type);
        this.state.is_first_cost_determination_mount = false;
      }
    },
    onContractCostDeterminationChange() {
      if (this.allCostsAreForInsurer()) {
        this.model.credit_type = CreditType.FULL;
      } else {
        this.model.credit_type = CreditType.LIMITED;
      }
    },
    allCostsAreForInsurer() {
      for (const id in this.model.cost_determinations) {
        if (this.model.cost_determinations.hasOwnProperty(id)) {
          const item = this.model.cost_determinations[id];
          if (item.selection != CostDeterminationSelection.INSURER) {
            return false;
          }
        }
      }

      return true;
    },
    onCreditTypeChange(creditType) {
      if (this.$refs.contractCostDeterminations) {
        if (creditType === CreditType.FULL) {
          this.$refs.contractCostDeterminations.setAll(
            CostDeterminationSelection.INSURER
          );
        }

        this.$refs.contractCostDeterminations.$forceUpdate();
      }

      if (!this.isLeaseCompanyCoveringCarPickupCosts()) {
        const cd = this.model.cost_determinations[
          this.cost_determination_car_pickup.id
        ];

        cd.selection =
          creditType === CreditType.FULL
            ? CostDeterminationSelection.INSURER
            : cd.selection;
      }

      this.$forceUpdate();
    },
    shouldShowPriceOverview() {
      return (
        this.vehicle.is_domestic &&
        this.deployment_prices &&
        this.day_prices &&
        (!this.contract_template ||
          this.contract_template.is_showing_price_overview)
      );
    },
    initContractCostDeterminationDict(
      costDeterminations,
      costDeterminationsMap = null,
      pivotCostDeterminations = null
    ) {
      const contract_cost_determinations_dict = {};

      costDeterminations.map(costDetermination => {
        let selection = null;
        let locked = null;

        if (costDeterminationsMap) {
          const costDeterminationPreset =
            costDeterminationsMap[costDetermination.id];
          selection = costDeterminationPreset?.selection;
          locked = costDeterminationPreset?.is_locked;
        }

        const contractCostDetermination = pivotCostDeterminations?.find(
          item => item.cost_determination_id == costDetermination.id
        );

        contract_cost_determinations_dict[costDetermination.id] = {
          selection: contractCostDetermination?.selection || selection,
          locked: locked
        };
      });

      this.model.cost_determinations = contract_cost_determinations_dict;

      this.$forceUpdate();
    },
    onLicensePlateSearchStart() {
      this.state.is_searching_license_plate = true;
    },
    getLanguageIdsForCountryId(countryId) {
      let countryIds = this.languages
        .filter(language => {
          return language.data.country_ids.includes(countryId);
        })
        .map(language => language.value);

      return countryIds.length ? countryIds : [countryId];
    },
    getDefaultCountryIds(model) {
      let countryIds = this.getLanguageIdsForCountryId(
        model.customer.address.country_id
      );

      countryIds = countryIds.concat(
        this.getLanguageIdsForCountryId(this.client.company.address.country_id)
      );

      if (model.location_type_drop_off == LocationType.DEPOT) {
        const depot = this.depots.find(d => d.value == model.depot_id_drop_off);

        if (depot) {
          countryIds = countryIds.concat(
            this.getLanguageIdsForCountryId(depot.data.address.country_id)
          );
        }
      }

      if (model.location_type_return == LocationType.DEPOT) {
        const depot = this.depots.find(d => d.value == model.depot_id_return);

        if (depot) {
          countryIds = countryIds.concat(
            this.getLanguageIdsForCountryId(depot.data.address.country_id)
          );
        }
      }

      for (
        let i = 0;
        i < this.state.manually_selected_language_ids.length;
        i++
      ) {
        const countryId = this.state.manually_selected_language_ids[i];
        countryIds = countryIds.concat(
          this.getLanguageIdsForCountryId(countryId)
        );
      }

      return [...new Set(countryIds)];
    },
    onLanguageSelect(value) {
      if (!this.state.manually_selected_language_ids.includes(value)) {
        this.state.manually_selected_language_ids.push(value);
      }
    },
    onLanguageDeselect(value) {
      const index = this.state.manually_selected_language_ids.indexOf(value);

      if (index > -1 && this.manually_selected_language_ids) {
        this.manually_selected_language_ids.splice(index, 1);
      }
    },
    onLicensePlateSearchComplete(result) {
      this.state.is_searching_license_plate = false;
      if (!result) return;
      this.model.conked_out_vehicle.brand_name = get(result.brand, "name");
      this.model.conked_out_vehicle.model_name = get(result.model, "name");

      this.$refs.conkedOutVehicleBrandName.$forceUpdate();
      this.$refs.conkedOutVehicleModelName.$forceUpdate();
    },
    onStartDatetimeChange() {
      if (this.$refs.priceOverview)
        this.$refs.priceOverview.calculateDeploymentPrice();
      this.$refs.dateDifferenceInput.onChange(
        this.$refs.dateDifferenceInput.getValue()
      );
    },
    onEndDatetimeChange() {
      this.$refs.dateDifferenceInput.recalcDifference();
      setTimeout(() => {
        this.recalculatePrices();
      }); // #cringe
    },
    onDateDifferenceChange(end) {
      this.model.end_datetime = toWeekday(end);
      this.$refs.endDatetimeDatepicker.$forceUpdate();
      this.$refs.dateDifferenceInput.recalcDifference();

      setTimeout(() => this.recalculatePrices());
    },
    onClientChange() {
      this.model.country_ids = this.getDefaultCountryIds(this.model);
    },
    onReturnDepotChange() {
      this.model.country_ids = this.getDefaultCountryIds(this.model);
    },
    onSubmitClick() {
      this.state.is_submitting = true;

      if (
        this.model.customer.email === undefined ||
        this.model.customer.email === ""
      ) {
        this.$dialog
          .confirm({
            title: i18n.app.common.warning,
            body: i18n.app.components.contract.customer_email_warning
          })
          .then(() => {
            this.$refs.form.submit(this.model);
          })
          .catch(() => {
            this.state.is_submitting = false;
          });
      } else {
        this.$refs.form.submit(this.model);
      }
    },
    onSuccess() {
      MapState.clear();
      FilterGroupCollection.clear();
      setTimeout(() => this.$router.push({ name: "contracts" }));
    },
    onFail() {
      this.$forceUpdate();
    },
    onDone() {
      this.state.is_submitting = false;
    },
    onSubmit(model) {
      const method = this.model.id ? "update" : "insert";

      if (method == "update") {
        model = pick(model, [
          "id",
          "start_datetime",
          "end_datetime",
          "remark",
          "customer"
        ]);
      } else {
        model.cost_determinations = this.model.cost_determinations;
        model.contract_template_id = this.contract_template?.id;
      }

      model.country_ids = this.model.country_ids.filter(item => item);
      model.selected_vehicle_segment_ids = this.selected_vehicle_segment_ids;

      return contractService[method](model);
    },
    onCancelPress() {
      this.$router.push("/");
    },
    onCountryChanged() {
      this.model.country_ids = this.getDefaultCountryIds(this.model);
    },
    recalculatePrices() {
      this.$forceUpdate();

      if (this.$refs.priceOverview) {
        this.$refs.priceOverview.calculatePrices();
      }
    },
    ...mapGetters({
      _client: "client",
      _clients: "clients"
    })
  }
};
</script>
